export const state = {
  modalViewUnilevel: false,
  unilevels: [],
  unilevel: {}
};

export default {};
